<div style="background-color: var(--tdo-background);" (appClickOutside)="onClickOutside()" data-cy="home-accordion-container">
  <mat-accordion class="home-accordion" data-cy="home-accordion">
    <!--SCHEDULE-->
    <mat-expansion-panel #schedDropdown (opened)="schedulePanelOpenState = true"
                         (closed)="schedulePanelOpenState = false" data-cy="home-accordion-schedule-panel">
      <mat-expansion-panel-header [ngStyle]="{'height': isExpanded ? '36px' : '50px'}" data-cy="home-accordion-schedule-header">
        <mat-panel-title style="color: white; height: 34px;" data-cy="home-accordion-schedule-title">
          <div class="accordion-header" data-cy="home-accordion-schedule-header-content">
            <div (contextmenu)="onSchedulerContextOpen($event); false;" matTooltip="Scheduler" style="flex-basis: fit-content; margin-right: 15px; position: relative; top: 1px;" data-cy="home-accordion-schedule-icon-container">
              <img style="height: 50%; cursor: pointer;" (click)="onScheduleIconClick()" src="assets/Images/landing/schedule.svg" data-cy="home-accordion-schedule-icon">
            </div>
            <div style="flex: 1; position: relative; top: 3px; white-space: nowrap; min-width: 100px;" data-cy="home-accordion-schedule-label">
              Schedule ({{homeAccordionService.numScheduleItems}})
            </div>
            <div style="flex-basis: 130px; position: relative; top: 3px; display: flex; text-align: center;" (mouseenter)="isDateHovered = true" (mouseleave)="isDateHovered = false" data-cy="home-accordion-schedule-date-control">
              <div [ngClass]="{'home-accordion-arrow-button': !isDateToday(), 'home-accordion-arrow-button-disabled': isDateToday()}" (click)="changeScheduleDate(false, $event, schedulePanelOpenState)" data-cy="home-accordion-schedule-prev-day">
                <mat-icon *ngIf="isDateHovered">keyboard_arrow_left</mat-icon>
              </div>
              <div style="flex-basis: fit-content; min-width: 120px;" data-cy="home-accordion-schedule-date">{{getDate()}}</div>
              <div class="home-accordion-arrow-button" (click)="changeScheduleDate(true, $event, schedulePanelOpenState)" data-cy="home-accordion-schedule-next-day">
                <mat-icon *ngIf="isDateHovered">keyboard_arrow_right</mat-icon>
              </div>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-home-schedule-view (accordionClose)="closeAccordion()" (requestClose)="homeAccordionCloseRequest();" (requestCheckOut)="schedDropdown.close();checkedOutState(); " data-cy="home-accordion-schedule-view"></app-home-schedule-view>
    </mat-expansion-panel>
    <!--TASKS-->
    <mat-expansion-panel *ngIf="isExpanded" data-cy="home-accordion-tasks-panel">
      <mat-expansion-panel-header data-cy="home-accordion-tasks-header">
        <mat-panel-title style="color: white; height: 34px;" data-cy="home-accordion-tasks-title">
          <div class="accordion-header" data-cy="home-accordion-tasks-header-content">
            <div style="flex-basis: fit-content; margin-right: 20px; margin-top: 1px;" data-cy="home-accordion-tasks-icon-container">
              <img style="height: 50%;" src="assets/Images/landing/tasks.svg" data-cy="home-accordion-tasks-icon">
            </div>
            <div style="flex: 1; position: relative; top: 3px;" data-cy="home-accordion-tasks-label">
              My To Do List({{this.TaskListService.tasks.getValue().length}})
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-tdo-task-list [isExpanded]=false (newItemEvent)="removeItemTask($event)" data-cy="home-accordion-task-list"></app-tdo-task-list>
      <!--<div class="home-accordion-task-content" style="display: flex; flex-direction: column; height: 100px;">
        <div class="home-accordion-task-header" style="flex-basis: fit-content;">
          Calls ({{callTasks.length}})
        </div>
        <div style="flex-basis: fit-content; display: flex; font-weight: 500;">
          <div style="flex: 1;">Patient Full Name</div>
          <div style="flex: 1; text-align: center;">Event/Case</div>
          <div style="flex: 1; text-align: right;">Phone #</div>
        </div>
        <div style="flex: 1; overflow-y: auto;">
          <div *ngFor="let ct of callTasks" style="display: flex;">
            <div style="flex: 1;">{{ (parseJson(ct.ContentParametersJSON).PatientName) }}</div>
            <div style="flex: 1; text-align: center;">{{ (parseJson(ct.ContentParametersJSON).CaseDesc) }}</div>
            <div style="flex: 1; text-align: right;">{{ (parseJson(ct.ContentParametersJSON).Phone) }}</div>
          </div>
        </div>
      </div>!-->
      <!--<div class="home-accordion-task-content">
        <div class="home-accordion-task-header">
          Reports ({{reportTasks.length}})
        </div>
        <div style="height: 60px; overflow-y: auto;">
          <div style="flex-basis: fit-content; display: flex; font-weight: 500;">
            <div style="flex: 1;">Patient Full Name</div>
            <div style="flex: 1; text-align: center;">Report</div>
            <div style="flex: 1; text-align: right;">Phone #</div>
          </div>
          <div style="flex: 1; overflow-y: auto;">
            <div *ngFor="let ct of reportTasks" style="display: flex;">
              <div style="flex: 1;">{{ (parseJson(ct.ContentParametersJSON).PatientName) }}</div>
              <div style="flex: 1; text-align: center;">{{ (parseJson(ct.ContentParametersJSON).CaseDesc) }}</div>
              <div style="flex: 1; text-align: right;">{{ (parseJson(ct.ContentParametersJSON).Phone) }}</div>
            </div>
          </div>
        </div>
      </div>!-->
      <!--<div class="home-accordion-task-content">
        <div class="home-accordion-task-header">
          Finances  ({{financeTasks.length}})
        </div>
        <div style="height: 60px; overflow-y: auto;">
          <div style="flex-basis: fit-content; display: flex; font-weight: 500;">
            <div style="flex: 1;">Patient Full Name</div>
            <div style="flex: 1; text-align: center;">Description</div>
            <div style="flex: 1; text-align: right;">Phone #</div>
          </div>
          <div style="flex: 1; overflow-y: auto;">
            <div *ngFor="let ct of financeTasks" style="display: flex;">
              <div style="flex: 1;">{{ (parseJson(ct.ContentParametersJSON).PatientName) }}</div>
              <div style="flex: 1; text-align: center;">{{ (parseJson(ct.ContentParametersJSON).CaseDesc) }}</div>
              <div style="flex: 1; text-align: right;">{{ (parseJson(ct.ContentParametersJSON).Phone) }}</div>
            </div>
          </div>
        </div>
      </div>!-->
    </mat-expansion-panel>
  <!--  RECENT PATIENTS-->
    <mat-expansion-panel #recPatExp *ngIf="isExpanded" (opened)="_recentPatientPanelOpenState = true"
                         (closed)="_recentPatientPanelOpenState = false" data-cy="home-accordion-recent-patients-panel">
      <mat-expansion-panel-header data-cy="home-accordion-recent-patients-header">
        <mat-panel-title style="color: white; height: 34px;" data-cy="home-accordion-recent-patients-title">
          <div class="accordion-header" data-cy="home-accordion-recent-patients-header-content">
            <div style="flex-basis: fit-content; margin-right: 20px; margin-top: 1px;" data-cy="home-accordion-recent-patients-icon-container">
              <img style="height: 50%;" src="assets/Images/landing/recent-patients.svg" data-cy="home-accordion-recent-patients-icon">
            </div>
            <div style="flex: 1; position: relative; top: 3px;" data-cy="home-accordion-recent-patients-label">
              Recent Patients
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-recent-patients data-cy="recent-patients-panel" [isOpen]="recentPatientPanelOpenState" [recentPatients]="patientService.recentPatients" (requestClose)="_recentPatientPanelOpenState = false; recPatExp.close();"></app-recent-patients>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<ng-template #ctxMenu let-data>
  <section class="context-menu" data-cy="home-accordion-scheduler-context-menu">
    <div (click)="openSchedulerInNewWindow()" class="item" data-cy="home-accordion-scheduler-new-window">Open in new window</div>
  </section>
</ng-template>
